export default {
  name: 'textarea',
  label: '多行文本',
  icon: 'el-icon-edit-outline',
  config: [{
    // 可修改的配置选项
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请输入'
    }
  }, {
    xtype: 'text',
    options: {
      label: '默认值',
      name: 'defaultVal',
      placeholder: '设置表单默认值'
    }
  }]
};